import "./errorComponent.scss";

interface ErrorComponentProps {
    errorText: string | any;
}

const ErrorComponent = (props: ErrorComponentProps) => {

    const { errorText } = props;

    return (
        <div className="error-component component error-text">
            { errorText }
        </div>
    );
};

export default ErrorComponent;